import { render } from "./Menubar.vue?vue&type=template&id=199d20aa"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"

import "./Menubar.vue?vue&type=style&index=0&id=199d20aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__